<template>
  <div 
    @click="goToItem()"
    :class="['sp-item d-block',cfg_size_small?'size-small':'cp']"
    >
    <div class="media">
      <div class="pic mr-1">
        <picColored
          :img="data.image_url || '/static/img/lion_full.png'"
        />
      </div>
      <div class="media-body">
        <h5 class="mt-2 mb-2 b">
          {{data.horse_name}}
        </h5>
        <div>
          <small class="op4">
            Z{{data.genotype}}
            ∙
            {{data.gender_str}}
            ∙
            {{data.horseRaceInfo.firstNumber}}/{{data.horseRaceInfo.secondNumber}}/{{data.horseRaceInfo.thirdNumber}}
            ∙
            {{data.horse_win_rate}}
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import picColored from '@/views/_cp_base/pic_colored.vue'

export default {
  name: 'horseItemSmallCard',
  components: {
    picColored,
  },
  props: [
    'data',
    'cfg_size_small',
    'cfg_no_link',
  ],
  data() {
    return {
      
    }
  },
  computed: {},
  watch: {
    '$route.params.id'(){
      this.getData()
    },
  },
  methods: {
    getData(){

    },
    goToItem(){
      let v = this

      if(v.cfg_no_link){return}

      v.$route.push({
        name: 'horse_item',
        params: {
          id: v.data.tokenID,
        },
      })
    },
  },
  created() {
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  .sp-item {

    &.size-small{
      padding: 0px 0;
      line-height: 18px !important;
      h5{
        font-size: 16px;
        margin-top: 2px !important;
        margin-bottom: 2px !important;
      }
      .pic{
        width: 40px;
        height: 40px;
      }
    }

    background-color: rgba(120,120,120, 0.1);
    border-radius: 10px;
    border: 1px solid rgba(120,120,120, 0.1);
    padding: 8px 0;
    &:hover{
      box-shadow: 0 0 0 1px rgba(120,120,120,0.5);
    }

    .pic{
      width: 70px;
      height: 70px;
    }

  }
</style>